import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Building2, Mail, Phone, MapPin, Calendar, User } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface TransporterDetailsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  company: any;
  orderNumber: string;
}

export const TransporterDetailsDialog = ({
  open,
  onOpenChange,
  company,
  orderNumber,
}: TransporterDetailsDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="text-2xl font-semibold text-[#37699E] font-heading flex items-center gap-2">
            <Building2 size={24} className="text-[#0880AE]" />
            Détails du transporteur
          </DialogTitle>
          <DialogDescription className="text-[#5A6B7A]">
            Réservation pour la commande {orderNumber}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-6 py-4">
          {/* Company Name */}
          <div className="space-y-2">
            <p className="text-xs font-medium text-[#5A6B7A] uppercase tracking-wide">
              Nom de l'entreprise
            </p>
            <p className="text-lg font-semibold text-[#2D3748]">{company?.name}</p>
          </div>

          {/* Company Type */}
          {company?.type && (
            <div className="space-y-2">
              <p className="text-xs font-medium text-[#5A6B7A] uppercase tracking-wide">
                Type
              </p>
              <Badge className="bg-[#0880AE] text-white">
                {company.type}
              </Badge>
            </div>
          )}

          {/* Contact Info */}
          <div className="space-y-3 pt-4 border-t border-[#DBE2EA]">
            <p className="text-xs font-medium text-[#5A6B7A] uppercase tracking-wide">
              Coordonnées
            </p>
            
            {company?.email && (
              <div className="flex items-start gap-3">
                <Mail size={18} className="text-[#0880AE] flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-xs text-[#5A6B7A]">Email</p>
                  <a 
                    href={`mailto:${company.email}`}
                    className="text-sm text-[#2D3748] hover:text-[#0880AE] transition-colors"
                  >
                    {company.email}
                  </a>
                </div>
              </div>
            )}

            {company?.phone && (
              <div className="flex items-start gap-3">
                <Phone size={18} className="text-[#0880AE] flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-xs text-[#5A6B7A]">Téléphone</p>
                  <a 
                    href={`tel:${company.phone}`}
                    className="text-sm text-[#2D3748] hover:text-[#0880AE] transition-colors"
                  >
                    {company.phone}
                  </a>
                </div>
              </div>
            )}
          </div>

          {/* Additional Info */}
          {(company?.address || company?.siret) && (
            <div className="space-y-3 pt-4 border-t border-[#DBE2EA]">
              <p className="text-xs font-medium text-[#5A6B7A] uppercase tracking-wide">
                Informations légales
              </p>
              
              {company?.address && (
                <div className="flex items-start gap-3">
                  <MapPin size={18} className="text-[#0880AE] flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="text-xs text-[#5A6B7A]">Adresse</p>
                    <p className="text-sm text-[#2D3748]">{company.address}</p>
                  </div>
                </div>
              )}

              {company?.siret && (
                <div className="flex items-start gap-3">
                  <User size={18} className="text-[#0880AE] flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="text-xs text-[#5A6B7A]">Identifiant fiscal</p>
                    <p className="text-sm text-[#2D3748]">{company.siret}</p>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
